// Angular
import { bootstrapApplication } from '@angular/platform-browser';
// Components
import { AppComponent } from './app/app.component';
// Config
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch(error => {
  console.error(error);
});
